module.exports = __webpack_public_path__ + "static/img/ikonaSluchowisko-OFF.2834a6b0.png";